import React, { useCallback } from 'react';
import Toast from '@boschebike/ebds-react/dist-esm/components/Toast.js';
import { hideToast, dequeueToast } from '../stores/slices/toast.slice.js';
import { useDodoDispatch, useDodoSelector } from './DodoStoreProvider.js';

export const ToastProvider = () => {
  const dispatch = useDodoDispatch();
  const state = useDodoSelector((st) => st.toast);

  const props = state.length > 0 ? state[0] : { id: 0, text: '' };

  const onDismiss = useCallback(() => {
    dispatch(hideToast());
    if (props.onDismiss) props.onDismiss();
  }, [dispatch, props.onDismiss]);

  const onClosed = useCallback(() => {
    dispatch(dequeueToast());
    if (props.onClosed) props.onClosed();
  }, [dispatch, props.onClosed]);

  return <Toast {...props} onDismiss={onDismiss} onClosed={onClosed} />;
};
